<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-07-25 15:39:21
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-10-10 10:51:07
 * @FilePath: \ces-vue-serve\src\views\Finance\waitDistribution.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="rj-page-card">
      <div class="rj-page-card__content">
        <el-form ref="searchForm" :inline="true" class="" :model="searchForm">
          <el-form-item label="订单编号:" prop="contractNum" clearable>
            <el-input v-model.trim="searchForm.contractNum" placeholder="请输入订单编号" />
          </el-form-item>
          <el-form-item label="标题:" prop="projectName" clearable>
            <el-input v-model.trim="searchForm.projectName" placeholder="请输入标题" />
          </el-form-item>
          <el-form-item label="客户名称:" prop="clientName" clearable>
            <el-input v-model.trim="searchForm.clientName" placeholder="请输入客户名称" />
          </el-form-item>
          <el-form-item label="订单分类:" prop="contractType">
            <el-select
              v-model="searchForm.contractType"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="option in orders"
                :key="option.dictValue"
                :label="option.dictLabel"
                :value="option.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="申请人:" prop="applicantName" clearable>
            <el-input v-model.trim="searchForm.applicantName" placeholder="请输入客户名称" />
          </el-form-item>
          <el-form-item label="申请时间:" prop="applicantTime">
            <div class="rj-flex">
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.applicantTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择时间"
                  clearable
                />
              </div>
              <div style="display: inline-block;width: 10px;text-align: center">
                -
              </div>
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.applicantEndTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择时间"
                  :picker-options="pickerOptions"
                  clearable
                />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="单据金额:" prop="orderAmount">
            <div class="rj-flex">
              <div class="rj-flex__item">
                <el-input-number v-model.trim="searchForm.orderAmount" :precision="2" :min="0" placeholder="单据金额" :controls="false" />
              </div>
              <div style="display: inline-block;width: 10px;text-align: center">
                -
              </div>
              <div class="rj-flex__item">
                <el-input-number v-model.trim="searchForm.orderEndAmount" :precision="2" :min="0" placeholder="单据金额" :controls="false" />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="已分配金额:" prop="amountAllocated">
            <div class="rj-flex">
              <div class="rj-flex__item">
                <el-input-number v-model.trim="searchForm.amountAllocated" :precision="2" :min="0" placeholder="已分配金额" :controls="false" />
              </div>
              <div style="display: inline-block;width: 10px;text-align: center">
                -
              </div>
              <div class="rj-flex__item">
                <el-input-number v-model.trim="searchForm.amountEndAllocated" :precision="2" :min="0" placeholder="已分配金额" :controls="false" />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="已分配比例:" prop="distributionRatio">
            <div class="rj-flex">
              <div class="rj-flex__item">
                <el-input-number v-model.trim="searchForm.distributionRatio" :precision="2" :min="0" :max="100" placeholder="已分配金额" :controls="false" />
              </div>
              <div style="display: inline-block;width: 10px;text-align: center">
                -
              </div>
              <div class="rj-flex__item">
                <el-input-number v-model.trim="searchForm.distributionEndRatio" :precision="2" :min="0" :max="100" placeholder="已分配金额" :controls="false" />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="最后分配时间:" prop="allocateTime">
            <div class="rj-flex">
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.allocateTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择时间"
                  clearable
                />
              </div>
              <div style="display: inline-block;width: 10px;text-align: center">
                -
              </div>
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.allocateEndTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择时间"
                  :picker-options="pickerOptions2"
                  clearable
                />
              </div>
            </div>
          </el-form-item>
          <el-button type="primary" :loading="isLoading" @click="doSearch">
            查询
          </el-button>
          <el-button type="default" @click="resetForm">
            重置
          </el-button>
        </el-form>
      </div>
    </div>
    <el-table v-loading="isLoading" :data="tableData" border style="width: 100%">
      <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
      <el-table-column prop="contractNum" label="订单编号" width="180" align="left" fixed="left" />
      <el-table-column prop="projectName" label="标题" align="left" min-width="100" />
      <el-table-column prop="clientName" label="客户名称" align="left" />
      <el-table-column prop="contractType" label="订单分类" align="left" />
      <el-table-column prop="applicantName" label="申请人" align="left" />
      <el-table-column prop="applicantTime" label="申请时间" width="140" align="left" />
      <el-table-column prop="orderAmount" label="订单金额" align="right" header-align="left" />
      <el-table-column prop="amountAllocated" label="已分配金额" align="right" header-align="left" />
      <el-table-column prop="distributionRatio" label="已分配比例" width="100" align="right" header-align="left">
        <template v-slot="{row}">
          {{ row.distributionRatio }}%
        </template>
      </el-table-column>
      <el-table-column prop="allocateTime" label="最后分配时间" align="left" />
      <el-table-column label="操作" align="left" width="170" fixed="right">
        <template v-slot="{row}">
          <el-button v-if="row.distributionRatio<100" type="text" @click="distribution(row)">
            分配
          </el-button>
          <el-button type="text" @click="checkDetail(row)">
            查看分配明细
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right;margin-top: 10px">
      <el-pagination
        :page-sizes="[10, 20, 30, 40]"
        :page-size.sync="page.pageSize"
        :current-page.sync="page.currentPage"
        layout="total, prev, pager, next, jumper,sizes"
        :total="page.total"
        hide-on-single-page
        @size-change="handerSizeChange"
        @current-change="handerCurrentChange"
      />
    </div>
    <el-dialog title="分配明细" :visible.sync="payForVisible" width="800px" @open="open">
      <el-table v-loading="istableDetailLoading" :data="tableDetailData" border style="width: 100%">
        <el-table-column type="index" width="60" label="序号" align="left" />
        <el-table-column prop="telegraphicTransferNum" label="电汇底单编号" align="left" />
        <el-table-column prop="orderSales" label="订单金额" align="right" header-align="left" />
        <el-table-column prop="assignAmount" label="已分配金额" align="right" header-align="left" />
        <el-table-column prop="usedScale" label="已分配比例" align="left">
          <template v-slot="{row}">
            <span>{{ row.usedScale }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createBy" label="分配人" align="left" />
        <el-table-column prop="createDate" label="分配日期" align="left" />
        <!--已抛到erp的合同，不允许撤销已分配的款项-->
        <el-table-column label="操作" align="left" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.buttonState === null && !this.$store.state.user.asSale" type="text" size="small" @click="cancelAllocation(scope.row)">
              撤销分配
            </el-button>
            <el-button v-if="scope.row.buttonState ==='可查看'" type="text" size="small" @click="showDetail(scope.row)">
              查看
            </el-button>
            <span v-if="scope.row.buttonState !== null && scope.row.buttonState !== '可查看'">
              {{ scope.row.buttonState }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="payForVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 撤销原因 -->
    <el-dialog v-if="causeRevocationVisible" title="撤销原因" :visible.sync="causeRevocationVisible" width="800px" @close="close">
      <el-input v-model="causeRevocation" type="textarea" maxlength="100" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="cancel">取消申请</el-button>
        <el-button type="primary" :loading="submitLoading" @click="onSubmit">提交申请</el-button>
      </span>
    </el-dialog>
    <!-- 查看 -->
    <el-dialog v-if="examineVisible" title="合同基本信息" :visible.sync="examineVisible" width="800px">
      <examine :id="approvalNumID" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="examineVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDictData, distributedOrder, viewingAllocationDetails, undoDistributionAgree } from '@/API';
import examine from '../../Chief/contract/common/examine.vue';
export default {
  components: {
    examine
  },
  data () {
    return {
      searchForm: {
        contractNum: '',
        projectName: '',
        clientName: '',
        applicantName: '',
        applicantTime: '',
        applicantEndTime: '',
        contractType: '',
        orderAmount: 0,
        orderEndAmount: undefined,
        amountAllocated: 0,
        amountEndAllocated: undefined,
        distributionRatio: 0,
        distributionEndRatio: undefined,
        allocateTime: '',
        allocateEndTime: '',
        distinguishList: 0

      },
      page: {
        pageSize: 10,
        total: 100,
        currentPage: 1
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.applicantTime) {
            let date = new Date(this.searchForm.applicantTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      pickerOptions2: {
        disabledDate: (time) => {
          if (this.searchForm.allocateTime) {
            let date = new Date(this.searchForm.allocateTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      isLoading: false,
      tableData: [],
      orders: [],
      payForVisible: false,
      tableDetailData: [],
      detailId: '',
      istableDetailLoading: false,
      causeRevocation: '', // 撤销原因
      causeRevocationVisible: false,
      examineVisible: false,
      approvalNumID: 0,
      postData: {},
      submitLoading: false
    };
  },
  computed: {

  },
  mounted () {
    this.initData();
  },
  methods: {
    initData () {
      let parmas = ['orders'];
      getDictData(parmas).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          // 下拉列表基础数据
          json.data.forEach((item) => {
            if (item.dictType === 'orders') {
              this.orders = item.dictDataVOS;
            }
          });
        }
      }).catch((err) => {
        console.log(err);
      });
      this.doSearch();
    },
    distribution (row) {
      this.$router.push({ name: 'FinanceBatchBase', query: row });
    },
    checkDetail (row) {
      this.detailId = row.id;
      this.payForVisible = true;
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.page.currentPage = 1;
      this.searchForm.applicantEndTime = '';
      this.searchForm.orderEndAmount = undefined;
      this.searchForm.amountEndAllocated = undefined;
      this.searchForm.allocateEndTime = '';
      this.searchForm.distributionEndRatio = undefined;
      this.doSearch();
    },
    doSearch () {
      this.isLoading = true;
      distributedOrder({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.isLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        } else {
          this.tableData = [];
          this.page.currentPage = 1;
          this.page.total = 0;
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.page.currentPage = val;
      this.doSearch();
    },
    open () {
      this.istableDetailLoading = true;
      this.openData();
    },
    openData () {
      viewingAllocationDetails(this.detailId).then((res) => {
        this.istableDetailLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableDetailData = json.data;
        } else {

        }
      }).catch(() => {
        this.istableDetailLoading = false;
      });
    },
    cancelAllocation (row) {
      this.causeRevocationVisible = true;
      this.postData.ids = [row.id];
    },
    showDetail (val) {
      this.approvalNumID = val.id;
      this.examineVisible = true;
    },
    onSubmit () {
      if (!this.causeRevocation) {
        this.$message.warning('撤销原因不能为空');
        return;
      }
      this.postData.type = 1;
      this.postData.reason = this.causeRevocation;
      this.submitLoading = true;
      undoDistributionAgree(this.postData).then((res) => {
        this.submitLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.$message({
            type: 'success',
            message: '成功撤销!'
          });

          this.openData();
          this.close();
        }
      }).catch(() => {
        this.submitLoading = false;
      });
    },
    cancel () {
      this.causeRevocationVisible = false;
      this.submitLoading = false;
      this.causeRevocation = '';
    },
    close () {
      this.cancel();
    }
  }
};
</script>

<style>

</style>
